/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevUserDto
 */
export interface DevUserDto {
    /**
     * 
     * @type {string}
     * @memberof DevUserDto
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof DevUserDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DevUserDto
     */
    email: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DevUserDto
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the DevUserDto interface.
 */
export function instanceOfDevUserDto(value: object): value is DevUserDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function DevUserDtoFromJSON(json: any): DevUserDto {
    return DevUserDtoFromJSONTyped(json, false);
}

export function DevUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'name': json['name'],
        'email': json['email'],
        'roles': json['roles'],
    };
}

export function DevUserDtoToJSON(json: any): DevUserDto {
    return DevUserDtoToJSONTyped(json, false);
}

export function DevUserDtoToJSONTyped(value?: DevUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'name': value['name'],
        'email': value['email'],
        'roles': value['roles'],
    };
}

